import React from "react";
import Calendar from "react-calendar";
import { FormControl, FormGroup, Overlay, Popover } from "react-bootstrap";
import Moment from "moment";
import { classNames } from "react-extras";
import unary from "lodash/unary";
const displayDateValue = (date, long) => Moment(date).format(long ? "MMM Do YYYY" : "MM/DD/YYYY");

const getDisplayValue = (noRange, value) => {
  if (noRange) {
    return displayDateValue(value || new Date(), true);
  }
  return (Array.isArray(value) ? value : []).map(date => displayDateValue(date)).join(" - ");
};

export const DateDisplay = React.forwardRef((props, ref) => {
  return (
    <>
      <FormGroup controlId="formBasicText" validationState={props.validationError && "error"}>
        <FormControl
          inputRef={inputRef => ref && (ref.current = inputRef)}
          type="text"
          readOnly
          value={getDisplayValue(props.noRange, props.value)}
          onClick={e => {
            props.onClick && props.onClick(e);
          }}
          className={classNames(props.onClick && "pointer", props.className)}
        />
      </FormGroup>
    </>
  );
});

class CalendarInput extends React.Component {
  state = {
    show: false,
  };
  updateShow = val => {
    this.setState({ show: val });
  };

  showCalendar = e => {
    e.stopPropagation();
    this.updateShow(true);
  };

  handleChange = e => {
    this.props.onChange(Array.isArray(e) ? e.map(unary(Moment)) : Moment(e));
    this.updateShow(false);
  };

  getCalendarValue() {
    const value = this.getValue();
    if (!value) {
      return value;
    }
    return Array.isArray(value) ? value.map(val => Moment(val).toDate()) : Moment(value).toDate();
  }

  overlay = () => {
    return (
      <Popover id={"calendar-popover"}>
        <div
          onClick={e => {
            e.nativeEvent.stopImmediatePropagation();
            e.preventDefault();
            e.stopPropagation();
          }}>
          <Calendar
            value={this.getCalendarValue()}
            minDate={this.props.minDate || new Date()}
            onChange={this.handleChange}
            selectRange={!this.props.noRange}
          />
        </div>
      </Popover>
    );
  };
  getValue = () => this.props.value || this.props.input?.value;
  render() {
    const validationError = (this.props.validationErrors ?? []).find(
      err => err?.fieldName === this.props.name
    )?.errorMessage;
    const ref = React.createRef();
    return (
      <div className={"position-relative"}>
        <DateDisplay
          validationError={validationError}
          ref={ref}
          noRange={this.props.noRange}
          value={this.getValue()}
          onClick={this.showCalendar}
        />

        <Overlay
          rootClose
          show={this.state.show}
          onHide={() => this.updateShow(false)}
          onEnter={() => this.updateShow(true)}
          target={() => ref.current}
          placement={"bottom"}>
          {this.overlay()}
        </Overlay>
        {this.props?.meta?.warning && <div className={"p-txxxs"}>{this.props.meta.warning}</div>}
      </div>
    );
  }
}

export default CalendarInput;
